import type {
  ConteudoCreateInputType,
  ConteudoOutputType,
  ConteudoUpdateInputType,
  MateriaCreateInputType,
  MateriaOutputType,
  MateriaUpdateInputType,
} from '../../../shared/dto';
import { callApi } from './call-api';

export const materiasApi = {
  listar: (_args: void) => callApi<MateriaOutputType[]>({ path: '/materias' }),

  criar: (body: MateriaCreateInputType) =>
    callApi<MateriaOutputType>({
      method: 'POST',
      path: '/materias',
      body,
    }),

  atualizar: ({ id, dados }: { id: string; dados: MateriaUpdateInputType }) =>
    callApi<MateriaOutputType>({
      method: 'PUT',
      path: `/materias/${id}`,
      body: dados,
    }),

  remover: (id: string) =>
    callApi<void>({
      method: 'DELETE',
      path: `/materias/${id}`,
    }),

  listarConteudos: (materiaId: string) =>
    callApi<ConteudoOutputType[]>({
      path: `/materias/${materiaId}/conteudos`,
    }),

  criarConteudo: (body: ConteudoCreateInputType) =>
    callApi<ConteudoOutputType>({
      method: 'POST',
      path: '/conteudos',
      body,
    }),

  atualizarConteudo: ({ id, dados }: { id: string; dados: ConteudoUpdateInputType }) =>
    callApi<ConteudoOutputType>({
      method: 'PUT',
      path: `/conteudos/${id}`,
      body: dados,
    }),

  removerConteudo: (id: string) =>
    callApi<void>({
      method: 'DELETE',
      path: `/conteudos/${id}`,
    }),
};
